import * as THREE from "three";
import { CSS2DObject } from "three/addons/renderers/CSS2DRenderer.js";
import { makeNanaHero } from "./figures";
import { PLANET_RADIUS, latLonToVector3, orientOnSphere, tangentBasis } from "./sphere";

export class Player {
  readonly group = new THREE.Group();
  moving = false;
  private visual = new THREE.Group();
  private leftLeg: THREE.Object3D | null = null;
  private rightLeg: THREE.Object3D | null = null;
  private leftArm: THREE.Object3D | null = null;
  private rightArm: THREE.Object3D | null = null;
  private reducedMotion = window.matchMedia("(prefers-reduced-motion: reduce)").matches;

  constructor() {
    this.group.name = "player";
    this.visual.name = "visual";
    this.group.add(this.visual);
    const hero = makeNanaHero();
    this.visual.add(hero);
    this.leftLeg = hero.getObjectByName("leftLeg") ?? null;
    this.rightLeg = hero.getObjectByName("rightLeg") ?? null;
    this.leftArm = hero.getObjectByName("leftArm") ?? null;
    this.rightArm = hero.getObjectByName("rightArm") ?? null;

    const tag = document.createElement("div");
    tag.className = "player-label";
    tag.textContent = "你";
    const label = new CSS2DObject(tag);
    label.position.set(0, 1.55, 0);
    this.group.add(label);

    const spawn = latLonToVector3(6, -150, PLANET_RADIUS);
    orientOnSphere(this.group, spawn, tangentBasis(spawn).north);
  }

  get position(): THREE.Vector3 {
    return this.group.position;
  }

  update(dt: number, time: number): void {
    void dt;
    const amp = this.moving && !this.reducedMotion ? 1 : 0;
    this.visual.position.y = Math.sin(time * 12) * 0.04 * (this.moving ? 1 : 0.15);
    const swing = Math.sin(time * 12) * 0.55 * amp;
    if (this.leftLeg) this.leftLeg.rotation.x = swing;
    if (this.rightLeg) this.rightLeg.rotation.x = -swing;
    if (this.leftArm) this.leftArm.rotation.x = -swing * 0.7;
    if (this.rightArm) this.rightArm.rotation.x = swing * 0.7;
  }
}
